/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import DeleteModal from "../Modal/DeleteModal";
import SaveHiringProcessPopup from "../Popup/SaveHiringProcessPopup";

import {
  challengeHeaderLinks,
  challnegeBreadCrumbText,
} from "helper/ChallengeHelper/ChallengeHelper";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { assetImages } from "constants";
import { useTranslation } from "react-i18next";

const HiringProcessBody = () => {
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");
  const { t } = useTranslation(); //for translation
  const [title, setTitle] = useState("");

  /* ---- bread crumb text ---- */
  const breadcrumbText = challnegeBreadCrumbText(t("Hiring Process"), title, t);

  // common header object
  const commonHeaderObject = challengeHeaderLinks(params.id, t);

  const [isLoading, setisLoading] = useState(false);
  const [processList, setprocessList] = useState([]);

  const [processId, setProcessId] = useState(null);

  //function for get project details
  const getJobDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CHALLENGE_DETAILS +
        `/${params.id}?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);
      if (response.status && response.data) {
        const data = response.data;
        setTitle(data.name);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAllJobProcess = async () => {
    try {
      setisLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_JOB_PROCESS +
        `?token=${token}&challengeid=${params.id}`;

      const response = await getData(requestUrl);

      console.log(response);

      setisLoading(false);

      if (response.status) {
        setprocessList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //delete process
  const deleteJobProcessHandler = async () => {
    try {
      let processFormData = {
        status: "0",
      };

      let requestUrl =
        url.API_BASE_URL +
        url.API_UPDATE_JOB_PROCESS +
        `/${processId}?token=${token}`;

      const response = await putData(requestUrl, processFormData);

      console.log("response of delete process----->", response);

      if (response.status) {
        setProcessId(null);
        getAllJobProcess();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (params.id) {
      getJobDetails();
      getAllJobProcess();
    }
  }, [params.id]);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_CHALLENGE")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pt-2 pt-lg-0 pb-5">
          {/* ---- common header ---- */}
          {params.id && (
            <TabsHeader
              commonHeaderObject={commonHeaderObject}
              activeOption={t("Hiring Process")}
            />
          )}

          <div className="container-fluid pt-4 pt-md-0 px-lg-5">
            {/* ---- bread crumb ------- */}
            <BreadCrumb breadCrumbText={breadcrumbText} bottom={true} />

            {/* --- survey container start ---- */}
            <div className="survey-container mt-4">
              {isLoading ? (
                <div className="placeholder-glow">
                  <div className="placeholder col-12 py-5 mb-4"></div>
                  <div className="placeholder col-12 py-5 mb-4"></div>
                  <div className="placeholder col-12 py-5 mb-4"></div>
                </div>
              ) : processList.length === 0 ? (
                /* Empty State */
                <div className="empty-state-card bg-white border border-gray-300 rounded-3 shadow-sm p-5 text-center mb-4">
                  <div className="empty-state-content">
                    <div className="empty-state-icon mb-4">
                      <div
                        className="icon-wrapper d-inline-flex align-items-center justify-content-center bg-gray-200 rounded-circle"
                        style={{ width: "80px", height: "80px" }}
                      >
                        <span
                          className="material-symbols-outlined text-gray-500"
                          style={{ fontSize: "36px" }}
                        >
                          work
                        </span>
                      </div>
                    </div>
                    <h4 className="mb-3 fw-semibold text-dark">
                      No Hiring Processes Yet
                    </h4>
                    <p className="mb-4 text-gray-500">
                      Start building your hiring process by adding your first
                      process. You can define different stages and KPIs.
                    </p>
                    <Link
                      to="#"
                      className="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasHiringProcess"
                      aria-controls="offcanvasHiringProcess"
                    >
                      <span className="material-symbols-outlined icon-sm">
                        add
                      </span>
                      <span className="fw-semibold">
                        {t("Add Your First Process")}
                      </span>
                    </Link>
                  </div>
                </div>
              ) : (
                processList.map((process, index) => {
                  return (
                    <div
                      className="question-card bg-white border border-gray-300 rounded-3 shadow-sm mb-4 overflow-hidden"
                      key={index}
                    >
                      {/* Process Header */}
                      <div className="question-header bg-light border-bottom border-gray-300 p-3 p-lg-4">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-3">
                            <div className="drag-handle text-gray-500 cursor-pointer d-flex align-items-center justify-content-center">
                              <span className="material-symbols-outlined icon-lg">
                                drag_indicator
                              </span>
                            </div>
                            <p className="mb-0 fs-lg fw-semibold text-dark">
                              {process.title}
                            </p>
                          </div>
                          <div className="question-actions d-flex align-items-center gap-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
                              style={{ width: "36px", height: "36px" }}
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvasHiringProcess"
                              aria-controls="offcanvasHiringProcess"
                              onClick={() => {
                                setProcessId(process._id);
                              }}
                              title="Edit Process"
                            >
                              <span className="material-symbols-outlined icon-sm">
                                edit
                              </span>
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center"
                              style={{ width: "36px", height: "36px" }}
                              data-bs-toggle="modal"
                              data-bs-target="#deleteModal"
                              aria-controls="deleteModal"
                              onClick={() => {
                                setProcessId(process._id);
                              }}
                              title="Delete Process"
                            >
                              <span className="material-symbols-outlined icon-sm">
                                delete
                              </span>
                            </button>
                            <button
                              className="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center"
                              style={{ width: "36px", height: "36px" }}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#panelsStayOpen-collapse${index}`}
                              aria-expanded="true"
                              aria-controls={`#panelsStayOpen-collapse${index}`}
                              title="Toggle Process Details"
                            >
                              <span className="material-symbols-outlined icon-sm">
                                expand_more
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Process Content */}
                      <div
                        id={`panelsStayOpen-collapse${index}`}
                        className="collapse show"
                      >
                        <div className="question-content p-3 p-lg-4">
                          {/* Preferred Location Section */}
                          <div className="question-section mb-4">
                            <div className="section-header d-flex align-items-center gap-2 mb-3">
                              <span className="material-symbols-outlined text-info icon-md">
                                my_location
                              </span>
                              <h6 className="mb-0 fs-md fw-semibold text-gray-600">
                                {t("Preferred Location")}
                              </h6>
                            </div>
                            <div className="section-content bg-gray-200 rounded-2 p-3">
                              <p className="mb-0 fs-md fw-semibold text-dark">
                                {process.location}
                              </p>
                            </div>
                          </div>

                          {/* Order and Dates Section */}
                          <div className="options-section mb-4">
                            <div className="section-header d-flex align-items-center gap-2 mb-3">
                              <span className="material-symbols-outlined text-warning icon-md">
                                calendar_month
                              </span>
                              <h6 className="mb-0 fs-md fw-semibold text-gray-600">
                                {t("Order & Dates")}
                              </h6>
                            </div>
                            <div className="section-content">
                              <div className="options-grid row g-2">
                                <div className="col-md-4">
                                  <div className="option-item p-3 rounded-2 border bg-gray-200 border-gray-300">
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="material-symbols-outlined icon-sm text-gray-500">
                                        format_list_numbered
                                      </span>
                                      <span className="fs-sm fw-medium text-dark">
                                        {t("Order")}: {process.order}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="option-item p-3 rounded-2 border bg-gray-200 border-gray-300">
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="material-symbols-outlined icon-sm text-gray-500">
                                        event
                                      </span>
                                      <span className="fs-sm fw-medium text-dark">
                                        {t("From")}: {process.startdate}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="option-item p-3 rounded-2 border bg-gray-200 border-gray-300">
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="material-symbols-outlined icon-sm text-gray-500">
                                        event
                                      </span>
                                      <span className="fs-sm fw-medium text-dark">
                                        {t("To")}: {process.enddate}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* KPIs Section */}
                          {process.kpisarr && process.kpisarr.length > 0 && (
                            <div className="options-section">
                              <div className="section-header d-flex align-items-center gap-2 mb-3">
                                <span className="material-symbols-outlined text-success icon-md">
                                  insights
                                </span>
                                <h6 className="mb-0 fs-md fw-semibold text-gray-600">
                                  {t("KPIs")}
                                </h6>
                              </div>
                              <div className="section-content">
                                <div className="options-grid row g-2">
                                  {process.kpisarr.map((kpis, index2) => {
                                    return (
                                      <div className="col-md-6" key={index2}>
                                        <div className="option-item p-3 rounded-2 border bg-gray-200 border-gray-300">
                                          <div className="d-flex align-items-center gap-2">
                                            <span className="material-symbols-outlined icon-sm text-gray-500">
                                              star
                                            </span>
                                            <span className="fs-sm fw-medium text-dark">
                                              {kpis.skillname}:{" "}
                                              {kpis.skillpoint} {t("Points")}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
              {/* Add Process Section */}
              <div
                className={
                  processList.length === 0
                    ? "d-none"
                    : "add-question-section mt-5"
                }
              >
                <div className="add-question-card bg-white border border-gray-300 rounded-3 shadow-sm p-4 text-center">
                  <div className="add-question-content">
                    <div className="add-question-icon mb-3">
                      <div
                        className="icon-wrapper d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 rounded-circle"
                        style={{ width: "60px", height: "60px" }}
                      >
                        <span
                          className="material-symbols-outlined text-primary"
                          style={{ fontSize: "28px" }}
                        >
                          add_circle
                        </span>
                      </div>
                    </div>
                    <h5 className="mb-2 fw-semibold text-dark">
                      {t("Add New Process")}
                    </h5>
                    <p className="mb-4 text-gray-500 fs-sm">
                      {t(
                        "Create a new hiring process to define stages and KPIs."
                      )}
                    </p>
                    <Link
                      to="#"
                      className="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasHiringProcess"
                      aria-controls="offcanvasHiringProcess"
                    >
                      <span className="material-symbols-outlined icon-sm">
                        add
                      </span>
                      <span className="fw-semibold">{t("Add Process")}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* --- survey container end ---- */}
          </div>
        </section>

        <SaveHiringProcessPopup
          processId={processId}
          setProcessId={setProcessId}
          onModalClose={getAllJobProcess}
        />
        {/* ----------------- delete modal -------------- */}
        <DeleteModal
          setProcessId={setProcessId}
          onDelete={deleteJobProcessHandler}
        />
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default HiringProcessBody;
